import axiosInstance from './axiosInstance';

export const createSupportTicket = (data) =>
	axiosInstance.post('/support/tickets', data);

export const getMySupportTickets = () =>
	axiosInstance.get('/support/tickets/mine');

export const getAdminSupportTickets = (params = {}) =>
	axiosInstance.get('/support/tickets/admin', { params });

export const getSupportTicket = (id) =>
	axiosInstance.get(`/support/tickets/${id}`);

export const addSupportTicketMessage = (id, data) =>
	axiosInstance.post(`/support/tickets/${id}/messages`, data);

export const updateSupportTicket = (id, data) =>
	axiosInstance.patch(`/support/tickets/${id}`, data);
